export const GET_CART_REQUEST = "GET_CART_REQUEST"
export const GET_CART_SUCCESS = "GET_CART_SUCCESS"
export const GET_CART_FAIL = "GET_CART_FAIL"

export const POST_TO_CART_REQUEST = "POST_TO_CART_REQUEST"
export const POST_TO_CART_SUCCESS = "POST_TO_CART_SUCCESS"
export const POST_TO_CART_FAIL = "POST_TO_CART_FAIL"

export const PUT_ADD_CART_REQUEST = "PUT_ADD_CART_REQUEST"
export const PUT_ADD_CART_SUCCESS = "PUT_ADD_CART_SUCCESS"
export const PUT_ADD_CART_FAIL = "PUT_ADD_CART_FAIL"

export const DELETE_CART_REQUEST = "DELETE_CART_REQUEST"
export const DELETE_CART_SUCCESS = "DELETE_CART_SUCCESS"
export const DELETE_CART_FAIL = "DELETE_CART_FAIL"